<template>
	<div class="list-container">
		<div class="list-grid">
			<div class="list-title">
				<div v-if="readerId == 0"></div>
				<div class="loading h2 h2-list" v-else-if="readerName == '' || readerName == 'undefined' || readerName == null">Loading</div>
				<h2 v-else>
					<router-link :to="{path:'/profile/' + readerId}">
						<router-link :to="{path:'/profile/' + readerId}" class="profile" v-bind:style="'background:' + readerProfileColour">profile</router-link>{{ readerName }}
					</router-link>
				</h2>
				<div class="loading h1 short" v-if="title == 'Books by undefined'">Loading</div>
				<h1 v-else>{{ title }}</h1>
			</div>
			<slot></slot>
		</div>
		<hr v-if="search">
		<div v-if="search" class="center-container">
			<h2 style="font-weight: bold; font-variation-settings: 'wght' 600;">Can't find the book you're looking for?</h2>
			<p>Bookplate is a community-sourced project. Contribute by adding the books we don't have in our databse yet.</p>
			<router-link :style="{display: 'inline-block'}" :to="'/add-new-book'" class="looks-like-button">Add new book</router-link>
		</div>
	</div>
</template>
<script>
export default
{
	props:
	[
		'title',
		'readerName',
		'readerId',
		'readerProfileColour',
		'search'
	]
}   
</script>